import PropTypes from 'prop-types';
import {
    EVENT_STATUS_BUTTON_UNPUBLISHED,
    EVENT_STATUS_BUTTON_PUBLISH_SCHEDULED,
    EVENT_STATUS_BUTTON_PUBLISHED,
    EVENT_STATUS_BUTTON_CANCELLED,
    EVENT_STATUS_BUTTON_ENDED,
} from '../constants';

export const FORM_HOOKS_PROPTYPE = PropTypes.shape({
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    dirty: PropTypes.bool.isRequired,
});

export const EVENT_SALES_STATUS_PROPTYPE = PropTypes.shape({
    salesStatusCode: PropTypes.string,
    salesStatusMessage: PropTypes.string,
    salesStatusMessageType: PropTypes.string,
    salesStatusMessageCode: PropTypes.string,
    isNotYetOnSale: PropTypes.bool,
    isOnSale: PropTypes.bool,
    isSoldOut: PropTypes.bool,
    salesStartDate: PropTypes.shape({
        utc: PropTypes.datetime,
        local: PropTypes.datetime,
        timezone: PropTypes.string,
    }),
});

export const PAGE_TYPE_PROP_TYPE = PropTypes.oneOf([
    'edit',
    'design',
    'manage',
]);

export const SERIES_CHILD_PROPTYPES = PropTypes.arrayOf(
    PropTypes.shape({
        eventId: PropTypes.string.isRequired,
        childDateTimeStart: PropTypes.string.isRequired,
        isCanceled: PropTypes.bool.isRequired,
    }),
);
export const EVENT_IDS_PROPTYPES = PropTypes.shape({
    eventId: PropTypes.string.isRequired,
    parentId: PropTypes.string,
    seriesUpcomingEventId: PropTypes.string,
});

export const VENUE_PROP_TYPE = PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
});

export const EVENT_STATUS_DATA_PROPTYPE = PropTypes.shape({
    eventDateRange: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    organizerId: PropTypes.string.isRequired,
    start: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    address: PropTypes.string,
    changed: PropTypes.datetime,
    timezone: PropTypes.string,
    hasSchedulePublish: PropTypes.bool,
    summary: PropTypes.string,
    hasTickets: PropTypes.bool,
});

export const EVENT_STATUS_BUTTON_TYPES = [
    EVENT_STATUS_BUTTON_UNPUBLISHED,
    EVENT_STATUS_BUTTON_PUBLISH_SCHEDULED,
    EVENT_STATUS_BUTTON_PUBLISHED,
    EVENT_STATUS_BUTTON_CANCELLED,
    EVENT_STATUS_BUTTON_ENDED,
];
